/**
 * The continent of a country (ISO 3166-1 alpha-2), by the United Nations'
 * regions (M49): the home page shows a visitor the cover photographs of
 * their own continent (owner, 2026-10-04). Turkey, Cyprus and the Caucasus
 * are in Asia there, Russia in Europe, Egypt in Africa.
 */
const REGIONS = {
  africa: "DZ AO BJ BW BF BI CV CM CF TD KM CD CG CI DJ EG GQ ER SZ ET GA GM GH GN GW KE LS LR LY MG MW ML MR MU YT MA MZ NA NE NG RE RW SH ST SN SC SL SO ZA SS SD TZ TG TN UG EH ZM ZW IO TF",
  americas: "AI AG AR AW BS BB BZ BM BO BQ BR VG CA KY CL CO CR CU CW DM DO EC SV FK GF GL GD GP GT GY HT HN JM MQ MX MS NI PA PY PE PR BL KN LC MF PM VC SX GS SR TT TC US UY VI VE BV",
  europe: "AX AL AD AT BY BE BA BG HR CZ DK EE FO FI FR DE GI GR GG VA HU IS IE IM IT JE XK LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SJ SE CH UA GB",
  asia: "AF AM AZ BH BD BT BN KH CN CY GE HK IN ID IR IQ IL JP JO KZ KW KG LA LB MO MY MV MN MM NP KP OM PK PS PH QA SA SG KR LK SY TW TJ TH TL TR TM AE UZ VN YE",
  oceania: "AS AU CK FJ PF GU KI MH FM NR NC NZ NU NF MP PW PG PN WS SB TK TO TV UM VU WF CX CC HM",
};

const CONTINENT_OF = new Map(
  Object.entries(REGIONS).flatMap(([continent, codes]) => codes.split(" ").map((code) => [code, continent])),
);

/** "africa", "americas", "europe", "asia" or "oceania"; null for an unknown or missing country. */
export function continentOf(country) {
  return CONTINENT_OF.get(String(country || "").trim().toUpperCase()) || null;
}

export const CONTINENT_CODES = Object.freeze(Object.fromEntries(
  Object.entries(REGIONS).map(([continent, codes]) => [continent, Object.freeze(codes.split(" "))]),
));
